module.exports = __webpack_public_path__ + "static/img/-analytics.6e5e2e56.png";